import z from "zod";
import { intl } from "LocaleWrapper";

export const deliveryConditionSchema = z.object({
	id: z.number().nullable(),
	key: z.string().min(1).max(255),
	description: z.string().min(1).max(255),
	showOnLocationPlanning: z.boolean(),
	showOnBulkPlanning: z.boolean(),
}).refine(data => data.showOnLocationPlanning || data.showOnBulkPlanning, {
	message: intl.formatMessage({ id: "DELIVERY_CONDITION_AT_LEAST_ONE_PLANNING_REQUIRED" }),
	path: [ "showOnLocationPlanning" ],
	when(payload) {
		return deliveryConditionSchema
			.pick({ showOnLocationPlanning: true, showOnBulkPlanning: true })
			.safeParse(payload.value)
			.success;
	},
});

export type DeliveryConditionSchemaInput = z.input<typeof deliveryConditionSchema>;
export type DeliveryConditionSchemaOutput = z.output<typeof deliveryConditionSchema>;
